import { atom } from "recoil";

export const addAdOverrideGroup = atom({
  key: "addAdOverrideGroup",
  default: false,
});

export const editOverrideGroup = atom({
  key: "editOverrideGroup",
  default: false,
});
